<footer>
    <div id="partners">
        <h4>O nosso parceiro:</h4>
        <a href="https://learning.dioscope.com/" target="_blank">
            <img
                src="./images/partners/dioscope_logo.png"
                loading="lazy"
                alt="dioscope logo"
                width="150"
                id="dioscope"
            />
        </a>
    </div>
</footer>

<style>
    footer {
        display: flex;
        margin-top: 20pt;
        margin-left: 1%;
        margin-right: 1%;
    }
    #partners {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: max-content;
    }

    h4 {
        width: max-content;
        font-size: 14px;
    }

    #dioscope {
        margin-top: -5pt;
        margin-left: -15pt;
    }
</style>
